import { createReducer } from "redux-starter-kit";
import {
  setMediasAction,
  setMediaUsedAction
} from "../actions/pdfEditArticleAVList";

const INIT_STATE = {
  medias: null
};

const pdfEditArticleAVList = createReducer(INIT_STATE, {
  [setMediasAction]: (state, action) => {
    state.medias = action.payload.medias;
  },
  [setMediaUsedAction]: (state, action) => {
    const mediaID = action.payload.mediaID;
    const articleID = action.payload.articleID;

    const media = state.medias.find(aMedia => aMedia.id === mediaID);

    if (media != null) {
      media.article = articleID == null ? null : { id: articleID };
    }
  }
});

export default pdfEditArticleAVList;
